import { useMemo, useState } from "react";

/**
 * A simple hook the retains a value even if it becomes undefined.
 * @param {*} value - the value preferred if defined
 * @param {*} defaultValue - the value returned if value was never defined ever
 * @returns
 */
const useLastOrDefault = (value, defaultValue) => {
  const [lastValue, setLastValue] = useState();

  const memoedValue = useMemo(
    () => value || lastValue || defaultValue,
    [value, lastValue, defaultValue]
  );

  if (lastValue !== memoedValue) setLastValue(memoedValue);

  return memoedValue;
};

export default useLastOrDefault;
